'use client';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getGameImagesByLocale } from '@/modules/promo/helpers/gamesByLocale';
import { TopGames } from '../TopGames';
import { ScGamesWrapper } from './styled';

export const RegModalGames = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const gameImages = useMemo(() => getGameImagesByLocale(language), [language]);

  return (
    <ScGamesWrapper>
      <TopGames
        centeredSlides
        customImages={gameImages}
        fullMobWidth
        loopSlider
        mobImgSize={132}
        showSlider
        slidesPerView={4}
      />
    </ScGamesWrapper>
  );
};
